import { render, staticRenderFns } from "./serviceManagementTable.vue?vue&type=template&id=13aa7f10&scoped=true"
import script from "./serviceManagementTable.vue?vue&type=script&lang=js"
export * from "./serviceManagementTable.vue?vue&type=script&lang=js"
import style0 from "./serviceManagementTable.vue?vue&type=style&index=0&id=13aa7f10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa7f10",
  null
  
)

export default component.exports